// extracted by mini-css-extract-plugin
var _1 = "VehicleBody-module__getStartedButtonContainer--Mc6zo";
var _2 = "VehicleBody-module__vehicleLoadingProgress--lAK2q";
export { _1 as "getStartedButtonContainer", _2 as "vehicleLoadingProgress" }
